/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { clearCvData, fetchCv, selectCvData, setCvData } from '../../../store/slices/api/inner/cvSlice';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import Main from '../../../components/HOC/Main';
import CustomTable from '../../../components/common/CustomTable';
import { formateDate } from '../../../components/common/FormateDate';

export const CvPage = () => {

  const cvData = useSelector(selectCvData);

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchCv,
    setValueAction: setCvData,
    clearValueActionOnError: clearCvData,
    isForm: false,
    successMessage: false,
  });

  const columns = useMemo(() => [
    {
      accessorKey: 'user',
      cell: info => <div>{info.getValue()?.name} {info.getValue()?.surname}</div>,
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'updatedAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
      'label':'Last updated'
    },
    {
      accessorKey: 'createdAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
    },

  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "user" }, { title: "cv" }]} >
      <CustomTable columns={columns} data={cvData}
      />
    </Main>
  );
};
